import { ErrorBoundary } from 'react-error-boundary';
import { Redirect, Switch, useRouteMatch } from 'react-router-dom';
import { DrawerRoute } from 'components/drawer-route';
import { handleRateLimitError } from 'components/error-boundaries/RateLimitErrorBoundary';
import { AuctionCategoriesDrawer } from 'components/pages/campaign-settings/campaign-auction/auction-categories/AuctionCategoriesDrawer';
import { ItemDetails } from 'components/pages/campaign-settings/campaign-auction/item-details';
import { DeclareWinnerDrawer } from 'components/pages/campaign-settings/campaign-auction/item-details/declare-winner/DeclareWinnerDrawer';
import { ItemForm } from 'components/pages/campaign-settings/campaign-auction/items-form';
import { ItemsIndex } from 'components/pages/campaign-settings/campaign-auction/items-index';
import { Route } from 'components/router/Route';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useFlags } from 'launchdarkly-react-client-sdk';

const ItemsRouter = () => {
    const match = useRouteMatch();

    return (
        <Switch>
            <Route
                path={[`${match.path}/:itemId(\\d+)`, `${match.path}/sponsor/:sponsorId(\\d+)`]}
                component={ItemRouter}
            />
            <Route path={match.path} component={ItemsIndexRouter} />
        </Switch>
    );
};

const ItemsIndexRouter = () => {
    const match = useRouteMatch();
    const { auctionsItemWinner } = useFlags();

    return (
        <>
            <DrawerRoute path={[`${match.path}/categories`]} component={AuctionCategoriesDrawer} />
            {auctionsItemWinner && (
                <DrawerRoute
                    path={[`${match.path}/declare-winner/:itemId`]}
                    component={DeclareWinnerDrawer}
                />
            )}
            <Switch>
                <Route path={`${match.path}/new`} component={ItemForm}>
                    {props => {
                        return (
                            <>
                                <DrawerRoute
                                    path={`${props.match?.path}/categories`}
                                    component={AuctionCategoriesDrawer}
                                />
                                <Switch>
                                    <Route path={props.match?.path} component={ItemForm} />
                                </Switch>
                            </>
                        );
                    }}
                </Route>
                <Route path={match.path} component={ItemsIndex} />
            </Switch>
        </>
    );
};

const ItemRouter = () => {
    const { accountId } = useCurrentAccount();
    const match = useRouteMatch<{ campaign_id: string }>();
    const { auctionsItemWinner } = useFlags();

    return (
        <ErrorBoundary
            onError={handleRateLimitError}
            fallback={
                <Redirect
                    to={`/accounts/${accountId}/campaigns/${match.params.campaign_id}/auction/items`}
                />
            }
        >
            {auctionsItemWinner && (
                <DrawerRoute
                    path={[`${match.path}/declare-winner`]}
                    component={DeclareWinnerDrawer}
                />
            )}
            <Switch>
                <Route
                    path={[
                        `${match.path}/edit`,
                        `${match.path}/duplicate`,
                        `${match.path}/template/:templateId`,
                    ]}
                >
                    {props => {
                        return (
                            <>
                                <DrawerRoute
                                    path={`${props.match?.path}/categories`}
                                    component={AuctionCategoriesDrawer}
                                />
                                <Switch>
                                    <Route path={props.match?.path} component={ItemForm} />
                                </Switch>
                            </>
                        );
                    }}
                </Route>
                <Route path={match.path} component={ItemDetails} />
            </Switch>
        </ErrorBoundary>
    );
};

export { ItemsRouter };
